import { css } from "styled-components";
import { getThemeData, createStyleComponent } from "@hzero-front-ui/core/lib/utils";
var tagStyle = function tagStyle(props) {
  var _getThemeData = getThemeData(props, "common"),
    primary = _getThemeData.primary;
  var _getThemeData2 = getThemeData(props, "tag"),
    background = _getThemeData2.background,
    color = _getThemeData2.color,
    borderRadius = _getThemeData2.borderRadius,
    checkedBackground = _getThemeData2.checkedBackground,
    checkedColor = _getThemeData2.checkedColor;
  return css([".ant-tag{border-radius:", ";&.ant-tag-checkable:active{background:", ";color:", ";}&.ant-tag-checkable-checked{background:", ";color:", ";a{color:", ";&:hover{color:", ";}}}&& .anticon-cross{color:#fff;}}[class=\"ant-tag\"]{background:", ";color:", ";a{color:", ";&:hover{color:", ";}}}"], borderRadius || "0.02rem", checkedBackground || primary, checkedColor || "#fff", checkedBackground || primary, checkedColor || "#fff", checkedColor || "#fff", checkedColor || "#fff", background || primary, color || "#fff", color || "#fff", color || "#fff");
};
export default createStyleComponent("tag", tagStyle);